export const bookingLink = '/pgu/ru/application/oiv/booking/';
export const mdMosRuLink = 'https://md.mos.ru/';
